module.exports = __webpack_public_path__ + "media/images/emblems/Rumendingen-coat_of_arms-d81819783b9f03b707cf74771d61d1a6.svg";